import '../shared'
import AttributesApp from './attributes-manager/App'
import i18n from 'live/services/i18n'
import { ConfigurationEntry, LiveApi } from 'live/lib/api'
import { enableMapSet } from 'immer'


import { routeAssetPage } from 'plugin-liverig/shared/asset/api'
import { withGlobalStyles } from 'plugin-liverig/shared/asset/lib/utils'
import { createGlobalStyle } from 'styled-components'

const MenuService = require('live/services/menu')
const ServiceLocator = require('live/services/service-locator').default

// To enable Immer to operate on the native Map and Set collections
enableMapSet()

const GlobalStyles = createGlobalStyle`
        .live-app {
            height: 100%;

            .app-footer {
                display: none;
            }
        }
    `

export const AttributesManager = () => {
    const menuItem: ConfigurationEntry = {
        name: 'Attributes Manager',
        addRoute: true,
        order: 0,
        url: '/#/config/attributes-manager',
        group: 'static-data',
        component: withGlobalStyles(AttributesApp, GlobalStyles),
        area: 'attributes-manager'
    }

    LiveApi.Extension.configuration.entries.register(menuItem)

    routeAssetPage('attributeManager', withGlobalStyles(AttributesApp, GlobalStyles))
    ServiceLocator.getService('asset-service').then((service: any) =>
        service.types.register({
            name: 'attributesManager'
        })
    )
}

try {
    require('./init')
    AttributesManager()
} catch (e) {
    console.error(e)
}
